import React from "react";

/**
 * @param {object} props
 * @param {{ id: string, label: string, icon?: string, to?: string, href?: string, end?: boolean }} props.item
 * @param {boolean} [props.isActive]
 * @param {string} [props.className]
 * @param {(item: object) => React.ReactNode} [props.renderLink]
 */
export function GsdModuleNavItem({ item, isActive = false, className = "", renderLink }) {
  const content = (
    <>
      {item.icon ? (
        <span className="gsd-nav-item__icon" aria-hidden="true">
          {item.icon}
        </span>
      ) : null}
      <span className="gsd-nav-item__label">{item.label}</span>
    </>
  );

  const cls = `gsd-nav-item${isActive ? " gsd-nav-item--active" : ""}${className ? ` ${className}` : ""}`;

  if (renderLink) {
    return (
      <span className="gsd-nav-item-wrap" data-testid={`gsd-nav-item-${item.id}`}>
        {renderLink(item, { isActive, className: cls, children: content })}
      </span>
    );
  }

  const href = item.to || item.href || "#";
  return (
    <a
      href={href}
      className={cls}
      aria-current={isActive ? "page" : undefined}
      data-testid={`gsd-nav-item-${item.id}`}
    >
      {content}
    </a>
  );
}
